
import { Component, OnInit } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { SwUpdate } from '@angular/service-worker';
import { environment } from '@env';
import { TranslateModule } from '@ngx-translate/core';
import { AppUpdateService } from '@services/app-update.service';
import { MatDividerModule } from '@angular/material/divider';
import moment from 'moment';
import { MatButtonModule } from '@angular/material/button';
@Component({
  selector: 'app-app-details-dialog-component',
  imports: [
    TranslateModule,
    MatDividerModule,
    MatButtonModule,
    MatDialogModule
  ],
  templateUrl: './app-details-dialog-component.component.html',
  styleUrl: './app-details-dialog-component.component.scss',
})
export class AppDetailsDialogComponentComponent implements OnInit {
  version_number = environment.version;
  build_number = environment.build;
  updated_at!: string;
  appUpdateStatus = false;
  loading = false;

  constructor(
    private appUpdateService: AppUpdateService,
    private swUpdate: SwUpdate,
    private dialogRef: MatDialogRef<AppDetailsDialogComponentComponent>
  ) {}

  ngOnInit() {
    this.updated_at = this.fromNow(environment.updated_at);
    this.appUpdateStatus = this.appUpdateService.isUpdateAvailable;
  }

  fromNow = (a: string | Date) => {
    if (moment().diff(a, 'hours') > 24) {
      return `at ${a}`;
    }
    return moment(a).fromNow();
  };
  reload() {
    window.location.reload();
  }

  checkForUpdates() {
    if (this.swUpdate.isEnabled) {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 3000);
      this.appUpdateService.updateChecker().subscribe(() => {
        this.appUpdateService.availableStatus.next(true);
        this.appUpdateStatus = true;
      });
    }
  }

  clearCache() {
    localStorage.clear();
    sessionStorage.clear();
    window.location.reload();
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
